import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}

	let arr = []

	const hasCertificate = !(
		injured.certificate &&
		['0', ''].includes(injured.certificate.hasCertificate)
	)

	if (hasCertificate) {
		let list = [{}]
		if (injured.certificate && injured.certificate.certificateList.length) {
			list = injured.certificate.certificateList
		}

		for (const item of list) {
			let certificateInfoArr = []
			certificateInfoArr.push(
				{
					label: '证件类型',
					value: setting.certiFiCatetypeMap[item.certificateType],
				},
				{
					label: '证件号',
					value: item.certificateNo,
				}
			)
			arr.push(certificateInfoArr)
		}
	}

	const obj = {
		title: '证件（资格证）信息',
		children: arr,
		show: {
			hasCertificate,
		},
	}

	return obj
}
